/**
 * Centralized event-name constants for the analytics bus and ad-conversion
 * pushes. Event names are a public contract for downstream dashboards and ad
 * conversions, so import from here instead of inlining string literals.
 */

// Internal in-app CustomEvent bus that producers dispatch on `window`. The
// `analytics-bridge` listens on this and forwards to PostHog.
export const ANALYTICS_BUS_EVENT = 'sossiety:analytics';

// PostHog reserved pageview event name.
export const POSTHOG_PAGEVIEW = '$pageview';

// Ad-conversion events pushed to `window.dataLayer` for GTM (Meta Pixel,
// Google Ads). Match the names marketing wires inside GTM.
export const GTM_SIGN_UP = 'sign_up';
export const GTM_REGISTRATION_COMPLETE = 'registration_complete';

// Revenue-funnel events emitted to the in-app bus and forwarded to PostHog.
// Names are a public contract for dashboards; see ANALYTICS_EVENT_MAP.md.
// Boundary: every event below fires BEFORE the corresponding database row
// is created, so we do not duplicate facts the Supabase integration owns.

// Roll review pre-pay funnel (rows are created on the pay click).
export const ROLL_REVIEW_FLOW_STARTED = 'roll_review_flow_started';
export const ROLL_REVIEW_INSTRUCTOR_SELECTED = 'roll_review_instructor_selected';
export const PRICING_VIEWED = 'pricing_viewed';

// Client-side payment validation errors before the PaymentIntent exists.
export const PAYMENT_FAILED_CLIENT = 'payment_failed_client';

// Video upload: the training_videos row is created only after upload success,
// so both lifecycle events live in PostHog.
export const VIDEO_UPLOAD_STARTED = 'video_upload_started';
export const VIDEO_UPLOAD_FAILED = 'video_upload_failed';

// Subscription funnel: the subscriptions row is only created on success.
export const SUBSCRIPTION_CHECKOUT_STARTED = 'subscription_checkout_started';
export const PAYWALL_DISMISSED = 'paywall_dismissed';

// Instructor payout setup: the stripe_accounts row is created on the
// start-onboarding click, so only the CTA impression is PostHog-owned.
export const PAYOUT_SETUP_CTA_SHOWN = 'payout_setup_cta_shown';
